import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReward, updateReward  , setPageSize , clearCache} from '../../slices/TransactionHistorySlice/RewardSlice';
// import Pagination from '../../components/Pagination';
import EditableTable from './RewardTable';
import Modal from '../../components/Modal';
import ChangeLog from '../../components/ChangeLog'; 
import Loader from "../../components/Loader";
import AddReward from './AddReward';
import { fetchRewardType } from '../../slices/TransactionHistorySlice/RewardTypeSlice'
import { fetchSurveyStatus } from '../../slices/TransactionHistorySlice/SurveyStatusSlice';

import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";


const Reward = () => {
  const dispatch = useDispatch();
  const { rewardList , currentPage, totalPages, status , search , pageSize } = useSelector((state) => state.reward);
  const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
  const [editedData, setEditedData] = useState({}); // Store temporary data for edited row

  const editableFields = ['is_read', 'body', 'title', 'status', 'rewardId', 'point', 'detail', 'mode', 'surveyStatus' ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [addModalDis, setAddModalDis] = useState(false);

  const [searchInput, setSearchInput] = useState(search || "");

  const hasData = rewardList?.result?.length > 0;
  const isSearching = searchInput && searchInput.trim() !== "";


  const rewardType = useSelector((state)  => state.rewardType);
  const surveyStatus = useSelector((state) => state.surveyStatus);

  useEffect(() => {
      // dispatch(fetchReward());

      dispatch(fetchReward({ page: 1, search}));

    if(rewardType.status === 'idle'){
      dispatch(fetchRewardType())
    }
    if(surveyStatus.status === 'idle'){
      dispatch(fetchSurveyStatus())
    }
  }, [dispatch]);


  // ✅ Debounced search (MAIN CONTROL)
    useEffect(() => {
      const timer = setTimeout(() => {
        dispatch(fetchReward({ page: 1, search: encodeURIComponent(searchInput) }));
      }, 800);
  
      return () => clearTimeout(timer);
    }, [searchInput]);
  
      // ✅ Page change
    useEffect(() => {
        dispatch(fetchReward({ page: currentPage, search :encodeURIComponent(searchInput) }));
    }, [currentPage]);


  // ✅ Page size change
  const handlePageSizeChange = (size) => {
    dispatch(setPageSize(size)); // update slice
    dispatch(fetchReward({ page: 1, search }));
  }; 


  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = rewardList.result?.find((user) => user.id === rowId);
    setEditedData(rowData); // Pre-fill the fields with current row data
  };

  const handleSave = async () => {
    // Extract only id, point, and detail for the API call
    const { id, title, status, point, rewardId, detail} = editedData;
    // console.log(rewardType.rewardTypeList)
    // console.log(editedData.mode)
    const mode = rewardType?.rewardTypeList?.result?.filter(f=>f.title === editedData.mode)[0]?.id;
    console.log("this is survey status",surveyStatus?.surveyStatusList?.result)
    const surveyStatusId = surveyStatus?.surveyStatusList?.result?.filter(f=>f.title === editedData.surveyStatus)[0]?.id;
    const updatedData = {id, title, status, point, rewardId, surveyStatus:surveyStatusId, mode, detail};

    await dispatch(updateReward(updatedData));
      await dispatch(clearCache());
    await dispatch(fetchReward({page: 1}));
    setEditRowId(null); // Exit edit mode after saving
  };

  const handleCancel = () => {
    setEditRowId(null); // Exit edit mode and reset data
    setEditedData({}); // Reset to original data
  };

  const handleLog = (id)=>{
    const logData = rewardList?.Change_Log?.filter((f)=> f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  const handleChange = (e, field,val) => {
    if(field ==="active" || field === "status" || field === 'is_read' ){
      setEditedData((prev) => ({
        ...prev,
        [field]:!val,
      }));
    }else{
      setEditedData((prev) => ({
        ...prev,
        [field]:e.target.value,
      }));
    }
};



  const headers = rewardList.result?.length > 0 ? Object.keys(rewardList.result[0]).filter((key) => key !== 'id') : [];

  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  // if (status === 'failed') {
  //   return <div>Error: {error}</div>;
  // }

  if (!rewardList || rewardList.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div className="w-full flex items-center flex-col">
      <div className="max-w-[93%] overflow-scroll">

          <PanelUserSearch  
            value={searchInput}
           onChange={setSearchInput}
          />
      
      
    <div >
        {hasData ? (
      <EditableTable
        headers={headers}
        rows={rewardList?.result || []}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable field
        rewardTypeList={rewardType?.rewardTypeList}
        surveyStatusList={surveyStatus?.surveyStatusList}
        // hideChangeLog={true}
      />

        ) : (
    <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

      {/* Icon */}
      <div className="text-5xl mb-3">🔍</div>

      {/* Message */}
      {searchInput ? (
        <>
          <p className="text-lg font-medium">No results found</p>
          <p className="text-sm mt-1">
            for "<span className="font-semibold">{searchInput}</span>"
          </p>
        </>
      ) : (
        <>
          <p className="text-lg font-medium">No Data Available</p>
          <p className="text-sm mt-1">
            There are no users to display
          </p>
        </>
      )}

    </div>
  )}
      </div>
    

{!(isSearching && !hasData) && (
<div className="flex mt-4 items-center justify-between">


    
    <PageSizeSelector
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
    />
    

  <SimplePagination
    currentPage={currentPage}
    setCurrentPage={(page) =>
      dispatch(fetchReward({ page, search : encodeURIComponent(searchInput) }))
    }
    totalPages={totalPages}
  />


   {/* <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={()=>setAddModalDis(true)}> Add POI</button> */}

</div>
 )}

      <Modal
        isOpen={addModalDis}
        onClose={()=>setAddModalDis(false)}
        title="Add POI"
        content={<AddReward/>}
      /> 

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />

    </div>
    </div>
  );
};

export default Reward;
